<script>
export default {
  name: 'ViewModeToggle',
  props: {
    value: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    getButtonClasses(option) {
      return [
        'view-mode-toggle__btn',
        {
          'view-mode-toggle__btn--selected': this.value === option.value,
        },
      ]
    },
  },
}
</script>

<template>
  <v-btn-toggle v-model="selected" dense mandatory class="view-mode-toggle">
    <v-btn
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      small
      :disabled="disabled"
      :title="option.title"
      :aria-label="option.title"
      :class="getButtonClasses(option)"
    >
      <v-icon class="view-mode-toggle__icon" size="20">
        {{ option.icon }}
      </v-icon>
    </v-btn>
  </v-btn-toggle>
</template>

<style lang="sass" scoped>
.view-mode-toggle
  display: flex
  align-items: center
  gap: 4px

  &__btn
    background: color-mix(in srgb, var(--secondary) 20%, transparent) !important
    border: none !important
    min-width: 24px !important
    width: 24px !important
    min-height: 24px !important
    height: 24px !important
    border-radius: 4px !important

    &:before
      background-color: transparent !important

    &--selected
      background: color-mix(in srgb, var(--primary) 20%, transparent) !important

      .view-mode-toggle__icon
        color: var(--primary) !important

  &__icon
    color: var(--secondary) !important
</style>
